/**
 * Styling for Choice Group Options.
 */
export const choiceGroupStyles = (theme) => ({
    labelWrapper: {
        overflow: 'visible',
        marginBottom: '1rem',
    },
});
